<div class="modal-body" id="modal-body">
  <ng-container *ngIf="contentType === 'detail'; else listBlock">
    <app-vrf-lan-subnets-detail [pk]="pk" [defaults]="defaults"
                                (detailSaved)="modal.close($event)"
                                (detailCancelled)="modal.dismiss()">
    </app-vrf-lan-subnets-detail>
  </ng-container>
  <ng-template #listBlock>
    <app-vrf-lan-subnets-list (rowClick)="modal.close($event)" [disableUrlUpdate]="true"
                              [disabledButtons]="localDisabledButtons" [disabledColumns]="localDisabledColumns"
                              [networkDevice]="networkDevice" [filters]="filters" [disableRouterLink]="true"
                              [entityView]='false'>
    </app-vrf-lan-subnets-list>
  </ng-template>
</div>